import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';
import Button from 'components/ui/Button';

const ServiceCard = ({ service, onEdit, onDelete, onToggleStatus }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleToggleStatus = async () => {
    setIsLoading(true);
    await onToggleStatus(service?.id);
    setIsLoading(false);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'ZAR'
    })?.format(price);
  };

  const getPopularityColor = (level) => {
    switch (level) {
      case 'high': return 'text-success';
      case 'medium': return 'text-warning';
      case 'low': return 'text-muted-foreground';
      default: return 'text-muted-foreground';
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { color: 'bg-green-500 text-success-foreground', label: 'Active' },
      inactive: { color: 'bg-muted text-muted-foreground', label: 'Inactive' },
      suspended: { color: 'bg-warning text-warning-foreground', label: 'Suspended' }
    };
    
    // const config = statusConfig?.[status] || statusConfig?.inactive;
    const config = status? statusConfig.active : statusConfig.inactive;
    
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-sm ${config?.color}`}>
        <div className={`status-indicator mr-1 text-xs ${status ? 'active' : 'inactive'}`}></div>
        {config?.label}
      </span>
    );
  };

  return (
    <div className="bg-card border border-border rounded-lg py-2 px-4 elevation-1 transition-smooth hover:elevation-2 relative">
      {/* <div className="absolute top-0 right-0 px-1 pt-2">
        <Button
          variant={service?.active ? "default" : "outline"}
          size="xs"
          onClick={handleToggleStatus}
          loading={isLoading}
          iconName={service?.active ? "Eye" : "EyeOff"}
          iconPosition="left"
          iconSize={12}
          className={`h-6 rounded-full ${service?.active ? "bg-success text-success-foreground hover:bg-success/50" : "bg-slate-300 text-muted-foreground hover:bg-muted/50"}`}
          title={service?.active ? "Active - Click to Deactivate" : "Inactive - Click to Activate"}
        >
          <span className='text-xs'>{service?.active ? "Active" : "Inactive"}</span>
        </Button>
      </div> */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold text-foreground mb-1">
              {service?.name}
            </h3>
            {getStatusBadge(service?.active)}
          </div>
          
          <div className="flex items-center space-x-4 text-sm text-muted-foreground">
            <div className="flex items-center space-x-1">
              <Icon name="Clock" size={14} />
              <span>{service?.duration} min</span>
            </div>
            {/* <div className="flex items-center space-x-1">
              <Icon name="TrendingUp" size={14} className={getPopularityColor(service?.popularity)} />
              <span className={getPopularityColor(service?.popularity)}>
                {service?.popularity} demand
              </span>
            </div> */}
          </div>
        </div>
      </div>
      {/* Service Description */}
      <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
        {service?.description}
      </p>
      {/* Pricing */}
      <div className="mb-4">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-foreground">Price</span>
          <span className="text-lg font-bold text-primary">
            {formatPrice(service?.currentAmount)}
          </span>
        </div>
        {service?.originalPrice && service?.originalPrice > service?.price && (
          <div className="flex justify-end">
            <span className="text-sm text-muted-foreground line-through">
              {formatPrice(service?.originalAmount)}
            </span>
          </div>
        )}
      </div>
      {/* AddOn */}
      {service?.addOn && (
        <div className="mb-4">
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-400 text-accent-foreground">
            Add-On Service
          </span>
        </div>
      )}
      {/* Equipment Required */}
      {/* {service?.equipment && service?.equipment?.length > 0 && (
        <div className="mb-4">
          <span className="text-xs font-medium text-muted-foreground mb-2 block">
            Equipment Required
          </span>
          <div className="flex flex-wrap gap-1">
            {service?.equipment?.slice(0, 3)?.map((item, index) => (
              <span
                key={index}
                className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-muted text-muted-foreground"
              >
                {item}
              </span>
            ))}
            {service?.equipment?.length > 3 && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-muted text-muted-foreground">
                +{service?.equipment?.length - 3} more
              </span>
            )}
          </div>
        </div>
      )} */}
      {/* Action Buttons */}
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onEdit(service)}
            iconName="Edit"
            iconPosition="left"
            iconSize={14}
            className="rounded"
          >
            Edit
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(service?.id)}
            iconName="Trash2"
            iconPosition="left"
            iconSize={14}
            className="text-destructive hover:text-white hover:bg-destructive rounded"
          >
            Delete
          </Button>
        </div>
        
        
      </div>
    </div>
  );
};

export default ServiceCard;